(() => {
  // app/scripts/components/ProductSelector/ProductSelectorSearch.js
  var ProductSelectorSearch = class extends HTMLElement {
    _loading = false;
    firstRender = false;
    callbacks = [];
    constructor() {
      super();
      this.selectedItem = null;
      this.prevSearchQuery = "";
      this.input = this.querySelector("textarea");
      this.resultsContainer = this.querySelector(".js-results-container");
      this.clearButton = this.querySelector(".js-clear-btn");
      this.form = this.querySelector("form");
      this.debounceExecuteSearch = debounce(this.executeSearch.bind(this), 500);
    }
    async connectedCallback() {
      this.initInputEvents();
      this.resultsContainer.addEventListener("click", this.handleResultClick.bind(this));
      this.clearButton.addEventListener("click", this.handleClearClick.bind(this));
    }
    initInputEvents() {
      this.input.addEventListener("input", (event) => {
        this.setInputHeight();
        this.debounceExecuteSearch(event);
      });
      this.input.addEventListener("focus", () => {
        this.classList.add("is-open");
      });
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.classList.remove("is-open");
        }
      });
    }
    handleClearClick() {
      this.input.value = this.prevSearchQuery;
      this.selectedItem = null;
      this.input.style.height = "auto";
      this.input.focus();
      this.setState("remove-selected");
      this.setState("show-results");
      this.callbacks.forEach((callback) => callback(null));
    }
    async executeSearch(event) {
      try {
        const queryString = new URLSearchParams(new FormData(this.form)).toString();
        const response = await fetch(`${theme.routes.predictiveSearch}?${queryString}`).then((res) => res.text());
        const div = document.createElement("div");
        div.innerHTML = response;
        const resultsHtml = div.querySelector("ul").outerHTML;
        const itemsCount = div.querySelector(".js-items-count").textContent;
        this.renderProducts(resultsHtml, +itemsCount);
      } catch (error) {
        throw error;
      }
    }
    setState(state) {
      switch (state) {
        case "show-results":
          this.classList.remove("is-loading");
          this.classList.add("is-results");
          break;
        case "loading":
          this.classList.remove("is-results");
          this.classList.add("is-loading");
          break;
        case "selected":
          this.classList.add("is-selected");
          this.classList.remove("is-results");
          this.input.readOnly = true;
          break;
        case "remove-selected":
          this.classList.remove("is-selected");
          this.input.readOnly = false;
          break;
        case "close":
          this.classList.remove("is-open");
          break;
        case "reset":
          this.classList.remove("is-selected", "is-results", "is-loading");
          this.input.readOnly = false;
          break;
      }
    }
    async renderProducts(html, itemsCount) {
      this.dataset.count = itemsCount;
      this.classList.toggle("is-empty", itemsCount === 0);
      this.resultsContainer.innerHTML = html;
      this.setState("show-results");
    }
    fetchProductCards(products) {
      const productIDs = products.map(({ ec_item_group_id }) => `id:${ec_item_group_id}`);
      return fetch(`${theme.routes.searchUrl}?type=product&q=${productIDs.join(" OR ")}`).then((res) => res.text());
    }
    handleResultClick(e) {
      const { target } = e;
      e.preventDefault();
      const parent = target.closest("[data-variant-id]");
      if (!parent)
        return;
      const { variantId, title, sku } = parent.dataset;
      const foundItem = { variantId, title, sku };
      this.setState("selected");
      this.setState("close");
      this.prevSearchQuery = this.input.value;
      this.selectedItem = foundItem;
      this.input.value = title;
      this.setInputHeight();
      this.callbacks.forEach((callback) => callback(foundItem));
    }
    onSelect(callback) {
      this.callbacks.push(callback);
    }
    setInputHeight() {
      this.input.style.height = "auto";
      this.input.style.height = this.input.scrollHeight + "px";
    }
    clearSelectedItem() {
      this.selectedItem = null;
      this.input.value = "";
      this.input.style.height = "auto";
      this.setState("reset");
    }
  };
  customElements.define("product-selector-search", ProductSelectorSearch);

  // app/scripts/product-selector.js
  var ProductSelector = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input[name='q']");
      this.quantity = this.querySelector("quantity-input");
      this.form = this.querySelector(".js-product-selector-form");
      this.callbacks = [];
      this.isLoading = false;
      this.searchBox = this.querySelector("product-selector-search");
    }
    connectedCallback() {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.searchBox?.onSelect?.(this.handleSelect.bind(this));
    }
    handleSelect(selectedVariant) {
      this.dataset.count = selectedVariant ? 1 : 0;
    }
    setState(state) {
      switch (state) {
        case "loading":
          this.classList.add("is-loading");
          break;
        case "selected":
          this.classList.add("is-selected");
          break;
        case "remove-selected":
          this.classList.remove("is-selected");
          this.selectedItem = null;
          break;
        default:
          this.classList.remove("is-loading");
          break;
      }
    }
    async handleSubmit(event) {
      try {
        event.preventDefault();
        if (this.isLoading)
          return;
        const selectedItemsValues = [{ ...this.searchBox.selectedItem, quantity: this.quantity.value }];
        this.setState("loading");
        Promise.all(this.callbacks.map((cb) => cb(selectedItemsValues))).finally(() => {
          this.setState();
          this.searchBox.clearSelectedItem();
          this.dataset.count = 0;
          this.quantity.value = 1;
        });
      } catch (error) {
        throw error;
      }
    }
    onAdd(cb) {
      this.callbacks.push(cb);
    }
  };
  customElements.define("product-selector", ProductSelector);
})();
